<mat-dialog-content class="mat-typography">
    <header class="modal-header">
        <h4 class="modal-title" id="attachment_title"> Attachments <span style="color: red;font-size: small;">Max size
                should not exceed 10 MB</span></h4>
        <i class="fa fa-window-close" style="font-size:14px; cursor: pointer" (click)="close.click()">
            <button #close style="display:none;" (click)="onNoClick()">
            </button>
        </i>
    </header>
    <br>
    <div class="main-content">
        <div class="col-md-12"  *ngIf="IsButtonHideAtt">
            <input type="file"
                accept=".xlsx,.pdf,.doc,.xls,.docx,.zip,.jpeg,.jpg,.png,.msg,.eml,image/*,application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint"
                (change)="onfilechange($event)" style="display: inline" />
            <button type="button" id="btnUpload" class="btn-primary1" (click)="UploadAttachment( this.IFileUpload)">
                <span class="hidden-xs" style="width: 80px;">Upload</span>
                <i class="fa fa-close hidden-lg hidden-md"></i>
            </button>
        </div>
        <div>&nbsp;</div>
        <div class="col-md-12" *ngIf="LocalAttachments?.length > 0">
            <table class="table">
                <tr>
                    <th>Attachment Description</th>
                    <th>By</th>
                    <th>Date & Time</th>
                </tr>
                <tr *ngFor='let url of LocalAttachments'>
                    <td style="padding: 5px;">
                        <div style="float: left;">
                            <mat-checkbox (change)="CheckChange($event.checked,url.AttachmentId)">

                            </mat-checkbox> <a style="cursor:pointer"
                                (click)="DownloadFile(url)">{{url.AttachmentName}}</a>
                        </div>

                    </td>
                    <td style="padding: 5px;">
                        <div style="float: left;">
                            <a style="cursor:pointer;">{{url.AttachmentByName}}</a>
                        </div>

                    </td>
                    <td style="padding: 5px;">
                        <div style="float: left;">
                            <a style="cursor:pointer;">{{url.AttachmentOn}}</a>
                        </div>

                    </td>
                </tr>
                <tr>
                    <td colspan="3">
                        <div class="col-md-3 right">
                            <button type="button" style="width: 100%" class="btn-primary1"
                                (click)="DeleteAttachment()" *ngIf="IsButtonHideAtt">Remove</button>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</mat-dialog-content>